import { useContext } from "react";
import { ComposerNarrowContext } from "./ComposerNarrowContext";

export const useComposerNarrow = () => useContext(ComposerNarrowContext);
